import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-194044d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column p-4"
}
const _hoisted_2 = { class: "pl-2" }
const _hoisted_3 = { class: "d-flex align-items-start" }
const _hoisted_4 = { class: "me-4" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "pl-2" }
const _hoisted_7 = { class: "d-flex align-items-start" }
const _hoisted_8 = { class: "me-4" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { class: "me-1" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createBlock(_component_ConfirmDialog, null, {
    message: _withCtx((slotProps) => [
      (_ctx.group =='confirmUnique')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(slotProps.message.message), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('client.date')) + ": " + _toDisplayString(_ctx.scheduleInformation.initDate), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('client.hour')) + ": " + _toDisplayString(_ctx.scheduleInformation.checkIn) + " - " + _toDisplayString(_ctx.scheduleInformation.checkOut), 1)
            ])
          ]))
        : (_ctx.group=='confirmRecurrent')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(slotProps.message.message), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('client.dateInit')) + ": " + _toDisplayString(_ctx.scheduleInformation.initDate), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('client.dateFinish')) + ": " + _toDisplayString(_ctx.scheduleInformation.finishDate), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('client.daysWeek')) + ": ", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleInformation.weekDays.sort((a,b)=>a-b), (day, index) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: index,
                    class: "me-1"
                  }, _toDisplayString(_ctx.daysWeek.find(d => d.id == day)?.name) + _toDisplayString(index < _ctx.scheduleInformation.weekDays.length - 1 ? ',' : ''), 1))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('client.hour')) + ": " + _toDisplayString(_ctx.scheduleInformation.checkIn) + " às " + _toDisplayString(_ctx.scheduleInformation.checkOut), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('client.noCreditsAlt')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('client.noCreditsAlt')), 1)
            ]))
    ]),
    _: 1
  }))
}